import React, { useEffect, useState } from "react";
import CongratulationInfoPopupComponent from "./CongratulationInfoPopup.component";
import { addFollow, cancelFollow } from "api/student/Follow.api";
import { fetchCongratulationInfo } from "api/student/v2/popup.api";
import { doLike } from "api/student/v2/congratulation.api";
const CongratulationInfoPopupContainer = (props: any) => {

    const [isLoading, setIsLoading] = useState(false);
    const [info, setInfo] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isOnNetworking, setIsOnNetworking] = useState(false);

    const getStudentData = async () => {
        console.log("getCongratulationInfo", props.congratulationId);
        if (!props.congratulationId) return;

        try {
            setIsLoading(true);
            const data = await fetchCongratulationInfo(props.congratulationId);
            if (data.info) {
                setInfo(data.info);
            }
        } catch (err: any) {
            console.error("학생 정보를 불러오는데 실패했습니다:", err);
            setErrorMessage(err.message || "Unknown Error");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getStudentData();
    }, [props.congratulationId]);

    const onLike = async (congratulationItemId: number) => {
        console.log("onLike", congratulationItemId);
        try {
            setIsOnNetworking(true);
            const result = await doLike(congratulationItemId);
            if (result?.data?.likeCount) {
                console.log("result", result);
                const item = info.congratulationItemList.find((item: any) => item.id === congratulationItemId);
                if (item) {
                    item.isLiked = true;
                    item.likeCount = result.data.likeCount
                }
            }
            console.log("doLike", result);
        } catch (err: any) {
            console.error("좋아요 처리에 실패했습니다:", err);
        } finally {
            setIsOnNetworking(false);
        }
    }


    return <CongratulationInfoPopupComponent
        onClose={props.onClose}
        info={info}
        isLoading={isLoading}
        errorMessage={errorMessage}
        onLike={onLike}
        isOnNetworking={isOnNetworking}
    />;
};

export default CongratulationInfoPopupContainer;